<template>
	<div>
		<div class="container-fluid">
			<form v-on:submit.prevent>
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">
						Profile Brand Name
						<sup>*</sup>
					</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-if="(profile.selected_profile && profile.selected_profile.name) || (!profile.brand_entity_id)"
							v-model="profile.selected_profile"
							:options="brandsList"
							:label="useLabel"
							:searchable="true"
							ref="multiselect"
							:track-by="profile_id"
							open-direction="bottom"
							placeholder="Brand profile"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							tagPlaceholder="Press enter to create new brand"
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							id="brands"
							@select="getBrand"
							@open="useLabel='customName'"
							@close="useLabel='name'"
						/>
						<input
							v-else
							v-on:keydown.enter.prevent
							type="text"
							name="entityId"
							v-model="profile.profile_brand_name"
							class="form-control"
							id="entityId"
							placeholder="Enter Profile Name"
							autocomplete="off"
						>
					</div>
					<div class="col-sm-2">
						<div v-if="profile.gettingProfileInfo" class="spinner-border"></div>
					</div>
				</div>
				<div v-if="profile.showProfileInfo">
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Brand Entity Id <sup>*</sup></label>
						<div class="col-sm-7 pr-5">
							<span
								class="no-data-style"
								v-if="profile.duplicateProfile"
							>Profile with this ID already exists</span>
							<input
								v-on:keydown.enter.prevent
								type="text"
								name="entityId"
								v-model="profile.brand_entity_id"
								class="form-control"
								id="entityId"
								placeholder="Brand entity id"
								autocomplete="off"
								v-on:input="checkProfileDuplicasy($event)"
							>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Country <sup>*</sup></label>
						<div class="col-sm-7 pr-5">
							<input
								v-on:keydown.enter.prevent
								type="text"
								name="entityId"
								v-model="profile.country_code"
								class="form-control"
								id="entityId"
								placeholder="Country code"
								autocomplete="off"
							>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Profile Type <sup>*</sup></label>
						<div class="col-sm-7 pr-5 text-capitalize">
							<input
								v-on:keydown.enter.prevent
								type="text"
								name="profileType"
								v-model="profile.profile_type"
								class="form-control"
								id="profileType"
								placeholder="Profile type"
								autocomplete="off"
								disabled="true"
							>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Marketing Campaign Type <sup>*</sup></label>
						<div class="col-sm-9">
							<div class="form-check d-inline-block">
								<input
									type="checkbox"
									v-model="profile.marketing_campaign_sb"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
								>
								<label
									class="form-check-label"
									for="dataPull1"
									style="vertical-align: middle !important;"
								>Sponsored Brands</label>
							</div>
							<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
								<input
									type="checkbox"
									v-model="profile.marketing_campaign_sp"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
								>
								<label
									class="form-check-label"
									for="dataPull2"
									style="vertical-align: middle !important;"
								>Sponsored Products</label>
							</div>
							<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
								<input
									type="checkbox"
									v-model="profile.marketing_campaign_sd"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
								>
								<label
									class="form-check-label"
									for="dataPull2"
									style="vertical-align: middle !important;"
								>Sponsored Display</label>
							</div>
							<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
								<input
									type="checkbox"
									v-model="profile.marketing_campaign_st"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
								>
								<label
									class="form-check-label"
									for="dataPull2"
									style="vertical-align: middle !important;"
								>Sponsored TV (North America only)</label>
							</div>
						</div>
					</div>
					<div class="form-group row" style="padding-left:0px">
						<div class="col-sm-3 col-form-label">
							<label class="form-check-label">Data Pull</label>
						</div>
						<div class="col-sm-7">
							<div class="form-check d-inline-block" style="display:flex !important">
								<input
									type="checkbox"
									v-model="profile.data_pull"
									value="true"
									style="padding-bottom:5px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
								>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Monthly Budget($)</label>
						<div class="col-sm-5 pr-5">
							<input
								type="text"
								name="baseApiUrl"
								v-model="profile.monthly_budget"
								class="form-control"
								id="baseApiUrl"
								placeholder="Monthly Budget"
								autocomplete="off"
								min="0"
								onkeypress="return event.charCode != 45"
								:disabled="true"
							>
						</div>
						<div class="col-md-2">
							<button
								class="btn btn-primary"
								style="font-size: 12px;"
								@click="openBudgetPopUp()"
							>Update Budget</button>
						</div>
					</div>
					<div class="form-group row" style="padding-left:0px">
						<div class="col-sm-3 col-form-label">
							<label class="form-check-label" for="exampleCheck1">Active</label>
						</div>
						<div class="col-form-label" style = "margin-left:15px;margin-right:30px">
							<div class="form-check d-inline-block" style="display:flex !important">
								<input
									type="checkbox"
									v-model="profile.active"
									:disabled="profile.active && (profile.disable_date!='' && profile.disable_date!=null)"
									value="true"
									style="padding-bottom:5px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete="off"
									@click="activeValueChange($event)"
								>
							</div>
						</div>
						<div class="col-sm-7 form-group" v-if="profile.showDate" style = "padding:0px">
							<div class="form-group col" style = "padding:0px">
								<div class="form-group row" style="margin:0px">
									<div
										class="col-form-label align-self-center"
										style="padding-top:0px;margin:0px;padding:0px;margin-top:0px"
										:style="ifDisabledOnPastDate(profile.disable_date)?'margin-top:5px':'margin-top:-4px'"
									>
										<label
											class="form-check-label"
											for="exampleCheck1"
										>{{ifDisabledOnPastDate(profile.disable_date)?'Disabled On '+ getFormattedDate(profile.disable_date):'Disables On'}}</label>
									</div>
									<div class="col-sm-5" style="padding-top:0px">
										<b-form-datepicker
											:id="index + '_disable'"
											name="disable_date"
											placeholder="MM/DD/YYYY"
											class="date_wrapper"
											v-model="profile.disable_date"
											menu-class="w-100"
											size="sm"
											:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
											calendar-width="180%"
											:hide-header="true"
											:today-button="false"
											:min="min_date_disable"
											locale="en"
											v-if="!ifDisabledOnPastDate(profile.disable_date)"
											@input="updateTheValidation(-1)"
										></b-form-datepicker>
									</div>
									<div
										class="col-sm-3"
										style="margin:0px;padding:0px;"
										v-if="!ifDisabledOnPastDate(profile.disable_date) && profile.disable_date && profile.active"
									>
										<button class="btn btn-primary" style="font-size: 12px;" @click="deleteDate">Delete Date</button>
									</div>
								</div>
								<!-- <div>
									<p
										style="font-size:13px;color:red;padding-top:10px"
										v-if="!ifDisabledOnPastDate(profile.disable_date)"
									>(Update will happen at 11:59pm on selected date)</p>
								</div> -->
							</div>
						</div>
						<div
							class="col-sm-1"
							style="text-align:center"
							v-if="profile.showDate && profile.disable_date && !ifDisabledOnPastDate(profile.disable_date)"
						>
							<p style="font-size:13px;color:orange">Pending InActive</p>
						</div>
					</div>

					<div class ="row" style ="padding-top : 10px" v-if="!ifDisabledOnPastDate(profile.disable_date) && profile.showDate">
						<div class ="msg-style">
							<p class = "msg-text-style" style = "">{{'Update will happen at 11:59pm on selected date'}}</p>
						</div>
					</div>
					<div
						class = "no-data-style row "
						style = "padding-top : 10px;margin-left:15px"
						v-if = "index == noDateForActiveFalse && profile.showDate">
						Provide Date to disable the profile
					</div>
				</div>
			</form>
		</div>
		<!-- budget updates -->
		<div

			class="modal fade"
			:id="'budgetPopUp_' + index"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Add/Edit Budget</h5>
						<button type="button" class="close"  @click = "resetPopUpData">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body text-center" v-if="getBudgetSpinner">
						<div class="spinner-border"></div>
					</div>
					<div class="modal-body" v-else>
						<div v-if="showToggle" class="form-group row ml-1 pl-1">
							<label style="color:#3da3a7;">
								<b>Show Expired Budget</b>
							</label>
							<toggle-button v-model="showExpired" value="showExpired"/>
						</div>
							<template v-for="(i,b_index) in Item.budget">
								<ModifyBudget
									ref = "budget_popup"
									:key="index + '-' + b_index"
									:arrIndex="b_index"
									:profileId="profile.selected_profile.id"
									:amsProfileId="profile.selected_profile.ams_profile_id"
									:budgetItems="Item.budget"
									@add="addToBudget"
									@delete="deleteFromBudget"
									@unhideShowAdd="unhideShowAdd"
									@hideShowAdd="hideShowAdd"
									@showToggleButton="showToggleButton"
									@decreementArrayDates="decreementArrayDates"
									@increementArrayDates="increementArrayDates"
									@alterEdit="alterEdit"
									@hideEmptyBudgetSpan="hideEmptyBudgetSpan"
									@getAccBudgetsByProfileId="getAccBudgetsByProfileId"
									:singleBudget="i"
									:showAdd="showAdd"
									:confirmDelete="confirmDelete"
									:startDateArray="startDateArray"
									:endDateArray="endDateArray"
									:allowEdit="allowEdit"
									:showExpired="showExpired"
								></ModifyBudget>
							</template>
							<span v-if="emptyBudgetSpan" style="color:red;font-size:13px;">All budget fields are mandatory</span>
							<div style="padding-left:10px;text-align: center;">
								<button
									v-on:click="addToBudget()"
									class="btn btn-primary form-group row"
									v-if="Item.budget.length == 0 || (notExpiredStatusArray.length == 0 && !showExpired)"
								>Configure Monthly Budget</button>
							</div>
							<!-- <div v-if="showWarning" class= "form-group row ml-2 mt-1">
								<span class ="no-data-style">You have left some unsaved changes. Either save or cancel them to proceed.</span>
							</div> -->
						</div>
						<div class="modal-footer" style = "flex: 0 0 auto">
							<div class="mt-2" style="text-align: center">
								<!-- <button type="button" @click="hideModal('cancel')" class="btn btn-secondary" data-dismiss="modal">D</button> -->
								<button
									type="button"
									class="btn btn-primary"
									@click = "resetPopUpData"
									>Close
								</button>
							</div>
						</div>

						<!--
					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "resetPopUpData">Close</button>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import moment from "moment";
	import datePicker from "vue-bootstrap-datetimepicker";
	import VendorPopUp from "@/components/account-management/VendorPopUp.vue";
	import ModifyBudget from "@/components/account-management/ModifyBudget.vue";
	const formatCurrency = require("format-currency");

	export default {
		name: "ProfileData",
		props: [
			"brandsList",
			"profile",
			"index",
			"updateDisableDate",
			"client_id",
			"vendorList",
			"sellerList",
			"noDateForActiveFalse"
		],
		components: {
			Multiselect,
			moment,
			datePicker,
			VendorPopUp,
			ModifyBudget
		},
		mounted() {
			if(this.profile){
				this.profile.monthly_budget = this.formatDailyBudget(this.profile.monthly_budget||0)
			}
		},
		data() {
			return {
				useLabel:'name',
				showToggle: false,
				showExpired: false,
				Item: {
					daily_budget: '0',
					budget: []
				},
				emptyBudgetSpan: false,
				notExpiredStatusArray: [],
				showAdd: false,
				allowEdit: true,
				confirmDelete: false,
				startDateArray: [],
				endDateArray: [],
				input: [],
				getBudgetSpinner: false,

				showVendorDropDown: false,
				selectedProfile: {},
				vendorActionType: "",
				showSellerDropDown: false,
				checkModify:false,
				activePresent:false,
				showWarning:false
			};
		},
		computed: {
			min_date_disable() {
				//only allow future dates, will prevent past as well as current date from selection
				return moment()
					.add(1, "days")
					.format("YYYY-MM-DD");
			}
		},
		watch: {
			profile() {
				if (this.profile.profile_type.toLowerCase() == "seller") {
					this.profile.showSeller = true;
				}
				if (this.profile.profile_type.toLowerCase() == "vendor") {
					this.profile.showVendor = true;
				}
				if(this.profile){
					this.profile.monthly_budget = this.formatDailyBudget(this.profile.monthly_budget||0)
				}
			}
		},
		methods: {
			moment,
			updateTheValidation(data){
				this.$emit("dateProvideDisableVAlidation", data)
			},

			openBudgetPopUp() {
				this.checkModify = true
				if (this.profile.selected_profile.id) {
					this.getBudgetSpinner = true;
					// this.getAccBudgetsByProfileId();
					this.getProfileBudgets()
				}
				let refer = "#budgetPopUp_" + this.index;
				$(refer).modal("show");
			},
			getProfileBudgets() {
				var vm = this;
				vm.Item.budget = [];
				var id = { profile_id: vm.profile.selected_profile.id };
				this.$store
					.dispatch("accounts/getAccBudgetsByProfileId", id)
					.then(response => {
						vm.input = response;
						for (var i = 0; i < vm.input.length; i++) {
							vm.Item.budget.push(vm.input[i]);
							vm.computeStatus();
						}
						vm.arrayOfDate();
						vm.confirmDelete = false;
						vm.getBudgetSpinner = false;
					});
			},
			getAccBudgetsByProfileId(callback) {
				var vm = this;
				vm.Item.budget = [];
				var id = { profile_id: vm.profile.selected_profile.id };
				this.$store
					.dispatch("accounts/getAccBudgetsByProfileId", id)
					.then(response => {
						vm.input = response;
						for (var i = 0; i < vm.input.length; i++) {
							vm.Item.budget.push(vm.input[i]);
							vm.computeStatus();
						}
						vm.arrayOfDate();
						vm.confirmDelete = false;
						if (callback) {
							callback();
						}
						vm.getBudgetSpinner = false;
					});
			},
			computeStatus() {
				this.notExpiredStatusArray = [];
				this.Item.daily_budget = '0';
				// if(this.Item.budget.length>0 && this.Item.budget[0].id ){
				// 	this.profile.monthly_budget = '0'
				// }
				//active flag resemble active budget in popup at an instance
				//activePresent resemble if active budget was there in popup for the very first instance when opened.
				var activeFlag = false
				this.showToggle = false;
				for (var i = 0; i < this.Item.budget.length; i++) {
					this.Item.budget[i].status = 'N/A'
					var status = moment()
						.subtract(1, "days")
						.isAfter(moment(this.Item.budget[i].end_date))
						? "Expired"
						: moment().isAfter(moment(this.Item.budget[i].start_date))
						? "Active"
						: "Pending";
					this.Item.budget[i].status = status;
					if (
						status == "Active" ||
						status == "notSet" ||
						status == "Pending"
					) {
						this.notExpiredStatusArray.push(status);
					}
					if (status == "Active") {
						this.Item.daily_budget = this.formatDailyBudget(
							this.Item.budget[i].budget
						);
						this.profile.monthly_budget = JSON.parse(JSON.stringify(this.Item.daily_budget))
						this.activePresent = true
						activeFlag = true
					}
					if (status == "Expired") {
						this.showToggle = true;
					}
				}
				if(!activeFlag && this.activePresent){
					this.profile.monthly_budget = '0'
				}
			},
			resetPopUpData(){
				// this.showWarning = false
				// if(this.Item.budget.findIndex(row=>!row.id) > -1){
				// 	this.showWarning = true
				// }
				// else if (this.Item.budget.findIndex(row=>!row.id) == -1){
				// 	this.showWarning = this.$refs['budget_popup'][0].checkIfUnsaved()
				// }
				// if(!this.showWarning){
				// 	this.showWarning = false
				// 	this.checkModify = false;
				// 	this.Item.budget = [];
				// 	this.$refs['budget_popup'][0].resetModifyBudget();
				// 	this.activePresent = false
				// 	let refer = "#budgetPopUp_" + this.index;
				// 	$(refer).modal("hide");
				// }
				// this.showWarning = false
					this.checkModify = false;
					this.Item.budget = [];
					this.$refs['budget_popup'][0].resetModifyBudget();
					this.activePresent = false
					let refer = "#budgetPopUp_" + this.index;
					$(refer).modal("hide");
				
			},
			formatDailyBudget(num) {
				var num = formatCurrency(num);
				return num;
			},
			showToggleButton(data) {
				this.showToggle = data;
				if (data == false) {
					this.showExpired = false;
				}
			},
			hideSpan() {
				this.showSpan = false;
				this.emptyCampGrpNameSpan = false;
			},
			arrayOfDate() {
				(this.startDateArray = []), (this.endDateArray = []);
				for (var i = 0; i < this.Item.budget.length; i++) {
					this.startDateArray.push(this.Item.budget[i].start_date);
					this.endDateArray.push(this.Item.budget[i].end_date);
				}
			},
			increementArrayDates(index) {
				// this.startDateArray.push(this.Item.budget[index].start_date);
				// this.endDateArray.push(this.Item.budget[index].end_date);
				this.arrayOfDate();
			},
			decreementArrayDates(index) {
				this.startDateArray.splice(index, 1);
				this.endDateArray.splice(index, 1);
			},
			addToBudget() {
				var budget = {
					budget: "",
					end_date: "",
					start_date: "",
					fallbackBudget: "0",
					status: "notSet"
				};
				this.Item.budget.push(budget);
				this.computeStatus();
			},
			deleteFromBudget(indexDel) {
				this.Item.budget.splice(indexDel, 1);
				this.computeStatus();
			},
			unhideShowAdd() {
				this.showAdd = true;
			},
			hideShowAdd() {
				this.showAdd = false;
			},
			alterEdit() {
				this.allowEdit = !this.allowEdit;
			},
			hideEmptyStrategySpan() {
				// if (this.Item.strategy == "Sales") {
				// 	this.roiSpend = "";
				// }
				this.emptyStrategySpan = false;
			},
			hideEmptyBudgetSpan() {
				this.emptyBudgetSpan = false;
			},
			getBrand(data) {
				let indx = this.index;
				let type = 'Ad Accounts'
				this.$emit("getBrandForId", data.ams_profile_id, indx, type);
			},
			ifDisabledOnPastDate(disableDate) {
				let x = moment(disableDate).isSameOrBefore(moment());
				return x;
			},
			getFormattedDate(date) {
				return moment(date).format("MM/DD/YYYY");
			},
			setDateFormat(date) {
				return moment().format("MM/DD/YYYY");
			},
			activeValueChange(val) {
				if (!val.currentTarget.checked) {
					this.$emit("updateDisableDate", this.index, true);
				} else {
					this.$emit("updateDisableDate", this.index, false);
				}
			},
			deleteDate() {
				this.$emit("removeDate", this.index);
			},
			checkProfileDuplicasy(event) {
				let data = event.currentTarget.value;
				this.profile.duplicateProfile = false;
				let isPresent = this.brandsList.find(
					e =>
						e.brand_entity_id &&
						e.brand_entity_id.toLowerCase().trim() ==
							data.toLowerCase().trim() &&
						e.name != this.profile.selected_profile.name
				);

				if (isPresent) {
					this.profile.duplicateProfile = true;
				} else {
					this.profile.duplicateProfile = false;
				}
			}
		}
	};
</script>

<style lang="scss">
.msg-style{
	width:100%;
	border:1px red solid;
	margin-left: 30px;
	margin-right: 30px;
	text-align: left;
}

.msg-text-style{
	font-size:15px;
	color:red;
	margin:0px;
	padding: 12px;
	font-weight: 500;
}
</style>
